import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { styled } from '@mui/material';
import { NotificationsActive } from '@mui/icons-material';
export const AnimatedBell = memo(function AnimatedBell() {
    return _jsx(BellIcon, { color: "action" });
});
const BellIcon = styled(NotificationsActive)(() => ({
    animation: 'bell 6s ease-out infinite',
    transformOrigin: 'center top',
    '@keyframes bell': {
        '0%': {
            transform: 'rotate(-35deg)',
        },
        '1.25%': {
            transform: 'rotate(-30deg)',
        },
        '2.5%': {
            transform: 'rotate(25deg)',
        },
        '3.75%': {
            transform: 'rotate(-20deg)',
        },
        '5%': {
            transform: 'rotate(15deg)',
        },
        '6.25%': {
            transform: 'rotate(-10deg)',
        },
        '7.5%': {
            transform: 'rotate(5deg)',
        },
        '10%': {
            transform: 'rotate(0)',
        },
    },
}));
